import React from "react";
import {
    DialogTitle,
    DialogActions,
    Button,
    DialogContent,
    Dialog,
    Typography,
    Box,
} from "@mui/material";
import DevelopmentNeedStatusDetails from "./DevelopmentNeedStatusDetails";

function DevelopmentNeedDialog({ open, onClose, data = {}, ...props }) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="lg">
            <DialogTitle>Development need</DialogTitle>
            <DialogContent dividers={false}>
                <Box className="dialog-content">
                    <DevelopmentNeedStatusDetails
                        status={data?.status}
                        dateCompletion={data?.dateCompletion}
                        dateReview={data?.dateReview}
                        dateEnd={data?.dateEnd}
                    />
                </Box>
                <Box className="dialog-content">
                    <Typography variant="h3" component="h3">
                        {data?.title}
                    </Typography>
                    <Typography variant="body1" mb={6}>
                        {data?.description}
                    </Typography>
                    <Typography variant="h3" component="h3" mb={1}>
                        How will you address this development need?
                    </Typography>
                    <Typography variant="body1" mb={6}>
                        {data?.planOfAction}
                    </Typography>
                    <Typography variant="h3" component="h3" mb={1}>
                        What resources do you need (if any)?
                    </Typography>
                    <Typography variant="body1" mb={6}>
                        {data.resourcesRequired}
                    </Typography>
                    <Typography variant="h3" component="h3" mb={1}>
                        How do you anticipate this will change your work?
                    </Typography>
                    <Typography variant="body1" mb={6}>
                        {data?.proposedOutcome}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DevelopmentNeedDialog;
